import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import { persistStore, persistReducer, createTransform } from 'redux-persist'
import combineReducers from '../slices/index' // Assuming you have a slice named itemSlice

// Configuration for redux-persist
// Transient UI state must never be restored from localStorage: a request that was
// interrupted by a refresh or logout would otherwise leave `loader: true` persisted
// and every button bound to it disabled until some other request completed.
const dropTransientFlags = createTransform(
  (inboundState) => inboundState, // state -> storage: unchanged
  (outboundState) => // storage -> state
    outboundState && typeof outboundState === 'object' && 'loader' in outboundState
      ? { ...outboundState, loader: false }
      : outboundState
)

const persistConfig = {
  key: 'root',
  storage,
  transforms: [dropTransientFlags]
}

// Combine all reducers
// const rootReducer = combineReducers(reducers)

// Wrap the rootReducer with persistReducer
const persistedReducer = persistReducer(persistConfig, combineReducers)

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false // Disable serializability check for persist
    })
})
export default store
export const persistor = persistStore(store)
